import React, { useEffect } from "react";
import {
    Box,
    Center,
    Flex,
    Image,
    Link,
    Heading,
    Tag,
} from "@chakra-ui/react";
import { CustomHead } from "components/custom-head";
import SearchBar from "components/search-bar";
import * as analytics from "utils/analytics";

export const GenerateCanva = ({ 
    title,
    subtitle,
    desc,
    url,
    image,
    placeholder="your input",
    suggestions=[] as any,
    nbSuggestions=25,
    sendRequest=undefined as any,
    onClickSuggestion=undefined as any,
    children,
    defaultValue="",
    isLoading,
    disableSearch=false,
    urlPrefix="/generate-tweets",
    utm_source="generate-tweets",
    headerGradient='linear(to-tr, #43cea2, #185a9d)',
    headerHeight=undefined as any,
    childrenMarginTop="100px",
    noIndex=false,
}) => {

    // const [value, setValue] = useState(defaultValue);
    // const searchInputBg = useColorModeValue("gray.50", "gray.700");

    useEffect(() => {
        analytics.init({});
    }, []);

    // console.log("suggestions", suggestions);

    return (

        <Box p={0} m={0}>

            <CustomHead
                title={title}
                desc={desc}
                url={url}
                image={image}
                noIndex={noIndex}
            />

            <Flex 
                minW="100%" 
                left="0" 
                top="0" 
                h={headerHeight ?? {md: "420px", base: "650px"}}
                // bgGradient='linear(to-tr, #F6A050, #E83A5C, #9B4193)' // A
                // bgGradient='linear(to-tr, #02aab0, #00cdac)' // B
                // bgGradient='linear(to-tr, #000428, #004e92)' // C
                bgGradient={headerGradient} // D
                // bgGradient='linear(to-tr, #2b5876, #4e4376)'
                alignItems="flex-start"
                justifyContent="flex-start"
                position="relative"
                p={{ base: 4, md: 10 }}
            >
                <Box maxW={1200} w="100%" h="100%" margin="auto" >
                    <Link href={"https://tweethunter.io?utm_source=" + utm_source}>
                        <Box display="flex" flexDirection="row" justifyContent="start" alignItems="center">
                            <Image src="/logo/logo_192.png" h="8" />
                            <Heading ml={3} fontSize="2xl" whiteSpace="nowrap" color="white">
                                Tweet Hunter
                            </Heading>
                        </Box>
                    </Link>

                    <Heading
                        mt={10}
                        mb={5}
                        as="h1"
                        justifyContent="center"
                        color="white"
                        fontSize="5xl"
                        fontWeight={600}
                        textAlign="center"
                    >
                        {title}
                    </Heading>
                    <Heading my={5} as="h2" color="gray.100" fontWeight={400} textAlign="center" fontSize="xl">
                        {subtitle}
                    </Heading>

                    {
                        suggestions?.length > 0 && (
                            <Center>
                                <Flex maxW="800px" w="100%" wrap="wrap" mt={5} justifyContent="center">
                                    {
                                        suggestions?.slice(0,nbSuggestions)?.map((suggestion, index) => (
                                            <Link key={suggestion.key} href={urlPrefix + "/" + suggestion.key}>
                                                <Tag 
                                                    key={index}
                                                    m={1}
                                                >
                                                    {suggestion.label}
                                                </Tag>
                                            </Link>
                                        ))
                                    }
                                </Flex>
                            </Center>
                        )
                    }

                    {
                        !disableSearch && (
                            <Flex position="absolute" bottom={{lg: "-60px", md: "-65px", base: "-60px"}}
                                left="50%" transform="translateX(-50%)"
                                w="80%" maxW="500px"
                                zIndex="1"
                            >
                                <SearchBar
                                    sendRequest={sendRequest}
                                    isLoading={false}
                                    placeholder="@twitter_handle"
                                    isSending={false}
                                    setIsSending={undefined}
                                    align="center"
                                    withHandleSuggestions={true}
                                    showButtonIcon={true}
                                    disableFilters={true}
                                    disableShadow={false}
                                    defaultValue={defaultValue}
                                    disableLocalSave={true}
                                />
                            </Flex>
                        )
                    }
                </Box>

                
            </Flex>

            <Box maxW={1200} margin="auto" mt={childrenMarginTop}>
                {children}
            </Box>

        </Box>
    );
};
